import { userAtom } from '@/global-store';
import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';

export interface GuestOrganisation {
  organisationId: number;
  name: string | null;
  isOrgadmin: 0 | 1;
}

export function useFetchGuestOrganisations() {
  const [user] = useAtom(userAtom);
  const userId = user?.id;

  return useQuery({
    enabled: !!userId,
    queryKey: [api.guestOrganisations, userId],
    queryFn: () =>
      fetchWrapper.get<GuestOrganisation[]>(api.guestOrganisations),
  });
}
